import { render, staticRenderFns } from "./OrganizationRetrieveUpdate.vue?vue&type=template&id=279629bb"
import script from "./OrganizationRetrieveUpdate.vue?vue&type=script&lang=js"
export * from "./OrganizationRetrieveUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports